// i18n: simple dictionary, no library overhead.
// t(key, lang) returns the translation for the given key.

export type Lang = 'tr' | 'en';

const dict: Record<string, Record<Lang, string>> = {
  // Header / nav
  appTitle: { tr: 'eSIM MARKET & COMPETITIVE RADAR', en: 'eSIM MARKET & COMPETITIVE RADAR' },
  weekLabel: { tr: 'Hafta', en: 'Week' },
  langToggle: { tr: 'EN', en: 'TR' },
  pdfExport: { tr: 'PDF', en: 'PDF' },
  emailShare: { tr: 'E-posta', en: 'Email' },
  radar: { tr: 'Radar', en: 'Radar' },
  pricing: { tr: 'Fiyatlandırma', en: 'Pricing' },
  benchmark: { tr: 'eSIM.io Karşılaştırma', en: 'eSIM.io Benchmark' },
  priceChanges: { tr: 'Fiyat Değişimi', en: 'Price Changes' },

  // Benchmark (eSIM.io comparison) tab
  benchmarkTitle: { tr: 'eSIM.io Fiyat Karşılaştırması', en: 'eSIM.io Price Benchmark' },
  benchmarkIntro: {
    tr: 'Her rakip planı, aynı bölgedeki eSIM.io planıyla yan yana koyar. Adil karşılaştırma için fiyatları aynı birime çeviriyoruz: belirli GB veren planlarda 1 GB’ın fiyatı, sınırsız planlarda 1 günün fiyatı. Eksi değer, rakibin eSIM.io’dan daha ucuz olduğunu gösterir.',
    en: 'Puts each rival plan side by side with the eSIM.io plan for the same region. To compare fairly we convert prices to the same unit: the price of 1 GB for plans with a set allowance, and the price of 1 day for unlimited plans. A negative value means the rival is cheaper than eSIM.io.',
  },
  benchmarkFallbackNote: {
    tr: 'Bu hafta eSIM.io tarafından yeterli fiyat toplanamadı. Karşılaştırma, eSIM.io fiyatının sağlam olduğu en son haftaya (Hafta {week}) göre yapılıyor.',
    en: 'This week’s eSIM.io pricing was too thin; the benchmark uses the most recent week with an eSIM.io baseline (Week {week}).',
  },
  benchmarkNoData: { tr: 'Karşılaştırılabilir eSIM.io tabanı bulunamadı.', en: 'No comparable eSIM.io baseline found.' },
  colProvider: { tr: 'Sağlayıcı', en: 'Provider' },
  colCountry: { tr: 'Bölge', en: 'Region' },
  colData: { tr: 'Veri', en: 'Data' },
  colDays: { tr: 'Gün', en: 'Days' },
  colRivalPrice: { tr: 'Rakip Fiyat', en: 'Rival Price' },
  colRivalUnit: { tr: 'Rakip Birim', en: 'Rival Unit' },
  colEsimioPrice: { tr: 'eSIM.io Fiyat', en: 'eSIM.io Price' },
  colEsimioUnit: { tr: 'eSIM.io Birim', en: 'eSIM.io Unit' },
  colDiff: { tr: 'Fark %', en: 'Difference %' },
  perGb: { tr: '$/GB', en: '$/GB' },
  perDay: { tr: '$/gün', en: '$/day' },
  cheaperThanEsimio: { tr: 'eSIM.io’dan ucuz', en: 'cheaper than eSIM.io' },
  pricierThanEsimio: { tr: 'eSIM.io’dan pahalı', en: 'pricier than eSIM.io' },
  noBaseline: { tr: 'eSIM.io tabanı yok', en: 'no eSIM.io baseline' },

  // Price-changes tab
  priceChangesTitle: { tr: 'Haftalık Fiyat Değişimleri', en: 'Weekly Price Changes' },
  priceChangesIntro: {
    tr: 'Geçen haftaya göre fiyatı değişen planlar. Bir planı geçen hafta göremediysek “önceki veri yok” yazıyoruz — değişim varmış gibi göstermiyoruz.',
    en: 'Plans whose price changed compared with last week. If we didn’t see a plan last week we write “no prior data” — we don’t pretend there was a change.',
  },
  priceChangesNoData: { tr: 'Karşılaştıracak önceki hafta verisi henüz yok.', en: 'There is no previous week yet to compare against.' },
  colOldPrice: { tr: 'Eski Fiyat', en: 'Old Price' },
  colNewPrice: { tr: 'Yeni Fiyat', en: 'New Price' },
  colChange: { tr: 'Değişim %', en: 'Change %' },
  noPriorData: { tr: 'önceki veri yok', en: 'no prior data' },
  priceUp: { tr: 'arttı', en: 'up' },
  priceDown: { tr: 'düştü', en: 'down' },
  likelyNoise: { tr: '⚠ veri kalitesi', en: '⚠ data quality' },
  likelyNoiseHint: {
    tr: 'Bu kadar büyük bir fark genellikle sağlayıcının sayfasını değiştirmesinden gelir, gerçek bir zam ya da indirim olmayabilir.',
    en: 'A difference this large usually comes from the provider changing its page, not from a real price increase or discount.',
  },
  providers: { tr: 'Sağlayıcılar', en: 'Providers' },
  // Version / update note (Radar page) — what changed in this release.
  versionNote: { tr: 'ŞU AN NEREDEYİZ', en: 'WHERE WE ARE' },
  versionNoteVersion: { tr: 'Panelin şu anki durumu · 25 Ağustos 2026', en: 'Panel status · 25 August 2026' },
  versionNoteFixed: {
    tr: 'Panel bu hafta 28 aktif sağlayıcıyı tarıyor: 154 plan, 145 teyitli fiyat, hepsi kaynak URL’siyle. Rekabet tarafında sinyaller üç blokta özetleniyor — KRİTİK, İZLE, STABİL — ve her sinyal Trustpilot, Reddit, Play Store ve sektör bloglarına kadar geri takip edilebiliyor. Bu haftanın nabzında 42 halka açık bahsedilme var; %74’ü Trustpilot, %17 blog, geri kalanı Reddit ve Play Store. Geçmiş haftalar arşivde: sağ üstteki hafta seçici ile geriye gidip aynı sağlayıcının fiyatı ya da kullanıcı yorum tonu nasıl değişmiş bakılabiliyor. Her sağlayıcı için ayrıntı sayfası açılıyor; plan tablosu, sinyal geçmişi, zaman içinde duygu grafiği ve doğrudan kaynağa gitmek için düğmeler var. Panelde gösterilen her kaynak linki — hem plan bazındaki fiyat linkleri hem de sağlayıcı sayfalarındaki “Web Sitesi / Planları Gör” düğmeleri — arka planda düzenli olarak ziyaret ediliyor; ulaşılamayan linkler tıklanabilir olmaktan çıkarılıp yerine amber “kaynağa ulaşılamıyor” etiketi konuyor, böylece hiçbir ölü link üzerinden karar verilmiyor.',
    en: 'The panel currently covers 28 active providers this week: 154 plans, 145 confirmed prices, each with a source URL. On the competitive side, signals are grouped into three blocks — CRITICAL, WATCH, STABLE — and every signal is traceable back to its source (Trustpilot, Reddit, Play Store, industry blogs). This week’s pulse contains 42 public mentions, 74% from Trustpilot, 17% from blogs, the rest from Reddit and Play Store. History is preserved: the week selector at the top right lets you go back and see how a provider’s pricing or user-review tone shifted over time. Each provider has its own detail page with a plan table, a signal history, a sentiment-over-time chart, and buttons that go straight to the source. Every source link shown on the panel — both per-plan pricing links and provider-level “Homepage / View Plans” buttons — is visited on a regular background check; links that no longer respond stop being clickable and are replaced with an amber “source not reachable” tag, so no decision is taken on top of a dead link.',
  },
  versionNoteFixed_disabled_old: {
    tr: 'Bu sürümde düzeltilen: Veri toplama zaman zaman yarıda kesiliyor ve o haftanın fiyatları eksik kalıyordu. Toplama baskı altında durduğunda başa dönmek yerine kaldığı yerden devam edecek ve topladığını anında saklayacak şekilde yeniden kuruldu. Bu haftanın fiyat verisi yeniden tam: 28 sağlayıcı, 154 plan, 145 teyitli fiyat. Ayrıca her fiyatın yanındaki “Kaynak” linki artık gösterilmeden önce gerçekten açılıp açılmadığı kontrol ediliyor; sağlayıcı sayfayı kaldırdıysa link yerine “kaynağa ulaşılamıyor” etiketi çıkıyor.',
    en: 'Fixed in this release: data collection sometimes stopped halfway, leaving that week’s prices incomplete. Collection was rebuilt so that when it stalls under load it resumes where it left off instead of starting over, and keeps what it has already gathered. This week’s pricing is complete again: 28 providers, 154 plans, 145 confirmed prices. Every “Kaynak” link is now checked before it is shown; if the provider has taken the page down, the link is replaced with a “source not reachable” tag instead of leading to a dead page.',
  },
  versionNoteKnown: {
    tr: 'Henüz zayıf olan: Kullanıcı yorumu tarafı bu hafta olması gerekenden az veri getirdi. Gelen yorumlar gerçek ve kaynaklı, ama sayı düşük. Sebebi belli ve bir sonraki sürümün ilk işi bu: yorumları tüm kaynaklara tek seferde sormak yerine her kaynaktan ayrı ayrı toplayacağız.',
    en: 'Still weak: the user-review side returned less than it should have this week. What came in is real and sourced, but the volume is low. The cause is understood and it is the first item in the next release: instead of asking all sources at once, we will collect from each source separately.',
  },
  versionNoteNext: {
    tr: 'Sıradaki: kaynak bazında yorum toplama, aktif indirim ve kupon takibi, uygulama puanı trendi, daha fazla sağlayıcı ve öncelikli ülke.',
    en: 'Coming next: per-source review collection, active discount and coupon tracking, app-rating trends, more providers and priority countries.',
  },
  sourceUnreachable: {
    tr: 'kaynağa ulaşılamıyor',
    en: 'source not reachable',
  },
  sourceUnreachableHint: {
    tr: 'Fiyatı ilk toplarken bu link çalışıyordu, sonradan sağlayıcı sayfayı kaldırdı ya da bota kapattı. Fiyatı kendiniz teyit etmek istiyorsanız sağlayıcının ana sayfasından arama yapın.',
    en: 'The link worked when we first collected the price; the provider has since removed the page or started blocking bots. To confirm the price yourself, search from the provider’s homepage.',
  },
  confidentialBanner: {
    tr: 'Gizli · eSIM.io ekibi için hazırlanmıştır',
    en: 'Confidential · Prepared for the eSIM.io team',
  },

  // Radar page
  weeklyPulse: { tr: 'HAFTALIK NABIZ', en: 'WEEKLY PULSE' },
  totalMentions: { tr: 'TOPLAM BAHSEDİLME', en: 'TOTAL MENTIONS' },
  criticalTheme: { tr: 'KRİTİK TEMA', en: 'CRITICAL THEME' },
  watchTheme: { tr: 'İZLE', en: 'WATCH' },
  stableTheme: { tr: 'STABİL', en: 'STABLE' },
  providerSentiment: { tr: 'OYUNCU BAZLI DUYGU ANALİZİ', en: 'PROVIDER SENTIMENT' },
  actionRecommendations: { tr: 'AKSİYON ÖNERİLERİ', en: 'ACTION RECOMMENDATIONS' },
  weeklyTrend: { tr: 'HAFTALIK TREND', en: 'WEEKLY TREND' },
  sentimentDistribution: { tr: 'DUYGU DAĞILIMI', en: 'SENTIMENT DISTRIBUTION' },
  themes: { tr: 'Temalar', en: 'Themes' },
  noData: { tr: 'Bu hafta için veri yok.', en: 'No data for this week.' },
  loading: { tr: 'Yükleniyor...', en: 'Loading...' },
  error: { tr: 'Hata oluştu.', en: 'An error occurred.' },

  // Status
  critical: { tr: 'KRİTİK', en: 'CRITICAL' },
  watch: { tr: 'İZLE', en: 'WATCH' },
  stable: { tr: 'STABİL', en: 'STABLE' },

  // Action focus
  product: { tr: 'ÜRÜN', en: 'PRODUCT' },
  support: { tr: 'DESTEK', en: 'SUPPORT' },
  growth: { tr: 'BÜYÜME', en: 'GROWTH' },
  market_watch: { tr: 'PİYASA TAKİBİ', en: 'MARKET WATCH' },

  // Priority
  p1: { tr: 'P1', en: 'P1' },
  p2: { tr: 'P2', en: 'P2' },
  p3: { tr: 'P3', en: 'P3' },

  // Pricing page
  pricingComparison: { tr: 'FİYAT KARŞILAŞTIRMASI', en: 'PRICING COMPARISON' },
  biggestMover: { tr: 'EN BÜYÜK HAREKET', en: 'BIGGEST MOVER' },
  provider: { tr: 'Sağlayıcı', en: 'Provider' },
  region: { tr: 'Bölge', en: 'Region' },
  plan: { tr: 'Plan', en: 'Plan' },
  data: { tr: 'Veri', en: 'Data' },
  validity: { tr: 'Geçerlilik', en: 'Validity' },
  priceUSD: { tr: 'Fiyat (USD)', en: 'Price (USD)' },
  perGB: { tr: '$/GB', en: '$/GB' },
  validityAdjusted: { tr: 'Geçerlilik-ayarlı', en: 'Validity-adjusted' },
  promoAdjusted: { tr: 'Promosyon-ayarlı', en: 'Promo-adjusted' },
  promo: { tr: 'Promosyon', en: 'Promo' },
  verified: { tr: 'Doğrulandı', en: 'Verified' },
  unverified: { tr: 'Doğrulanmamış', en: 'Unverified' },
  unlimited: { tr: 'Sınırsız', en: 'Unlimited' },

  // Region filters
  allRegions: { tr: 'Tüm Bölgeler', en: 'All Regions' },
  global: { tr: 'Global', en: 'Global' },
  europe: { tr: 'Avrupa', en: 'Europe' },
  us: { tr: 'ABD', en: 'US' },
  asia: { tr: 'Asya', en: 'Asia' },
  turkey: { tr: 'Türkiye', en: 'Turkey' },

  // Filters
  unlimitedOnly: { tr: 'Yalnızca Sınırsız', en: 'Unlimited Only' },
  promosOnly: { tr: 'Yalnızca Promosyonlar', en: 'Promos Only' },
  verifiedOnly: { tr: 'Yalnızca Doğrulanmış', en: 'Verified Only' },

  // Sorting
  sortAsc: { tr: '↑', en: '↑' },
  sortDesc: { tr: '↓', en: '↓' },

  // Provider page
  plans: { tr: 'Planlar', en: 'Plans' },
  signalHistory: { tr: 'Sinyal Geçmişi', en: 'Signal History' },
  sentimentOverTime: { tr: 'Zaman İçinde Duygu', en: 'Sentiment Over Time' },
  diffsThisWeek: { tr: 'Bu Hafta Farklar', en: 'Diffs This Week' },
  noDiffs: { tr: 'Bu hafta fark yok.', en: 'No diffs this week.' },
  noPlans: { tr: 'Bu hafta plan yok.', en: 'No plans this week.' },
  category: { tr: 'Kategori', en: 'Category' },
  consumer_esim: { tr: 'Tüketici eSIM', en: 'Consumer eSIM' },
  corporate_iot: { tr: 'Kurumsal & IoT', en: 'Corporate & IoT' },
  airline_wifi: { tr: 'Uçak İçi Bağlantı', en: 'In-Flight Connectivity' },
  // Legacy keys (kept for backward compat during migration)
  established: { tr: 'Tüketici eSIM', en: 'Consumer eSIM' },
  new_entrant: { tr: 'Tüketici eSIM', en: 'Consumer eSIM' },
  homepage: { tr: 'Web Sitesi', en: 'Homepage' },
  viewPlans: { tr: 'Planları Gör', en: 'View Plans' },

  // Digest page
  weeklyDigest: { tr: 'HAFTALIK ÖZET', en: 'WEEKLY DIGEST' },
  digestReadOnly: { tr: 'Salt okunur haftalık özet görünümü.', en: 'Read-only weekly digest view.' },

  // Auth gate
  enterCode: { tr: 'Erişim Kodu', en: 'Access Code' },
  codePrompt: { tr: 'Pano erişimi için kod gereklidir.', en: 'A code is required to access the dashboard.' },
  submit: { tr: 'Gir', en: 'Enter' },
  invalidCode: { tr: 'Geçersiz kod.', en: 'Invalid code.' },

  // Charts
  positive: { tr: 'Pozitif', en: 'Positive' },
  neutral: { tr: 'Nötr', en: 'Neutral' },
  negative: { tr: 'Negatif', en: 'Negative' },
  mentions: { tr: 'Bahsedilme', en: 'Mentions' },

  // Change indicators
  change: { tr: 'Değişim', en: 'Change' },
  previous: { tr: 'Önceki', en: 'Previous' },
  current: { tr: 'Mevcut', en: 'Current' },
  delta: { tr: 'Fark', en: 'Delta' },
  days: { tr: 'gün', en: 'days' },
  gb: { tr: 'GB', en: 'GB' },

  // Misc
  impact: { tr: 'Etki', en: 'Impact' },
  finding: { tr: 'Bulgu', en: 'Finding' },
  relatedProviders: { tr: 'İlgili Sağlayıcılar', en: 'Related Providers' },
  sourceExamples: { tr: 'Kaynak Örnekleri', en: 'Source Examples' },
  searchThisSource: { tr: 'Bu kaynağı web’de ara', en: 'Search this source on the web' },
  trend: { tr: 'Trend', en: 'Trend' },
  notAvailable: { tr: 'Mevcut değil', en: 'Not available' },

  // 'How to read' framing block (Radar page top)
  howToRead: { tr: 'NASIL OKUNUR', en: 'HOW TO READ' },
  howToReadPurpose: {
    tr: 'Bu panel, eSIM ve uluslararası bağlantı pazarının haftalık rekabet fotoğrafıdır. Her Pazartesi sabahı kendi kendine çalışır ve üç yere bakar: sağlayıcıların kendi fiyat sayfaları, sektör haberleri ve kullanıcıların herkese açık yorumları.',
    en: 'This dashboard is a weekly picture of competition in the eSIM and international connectivity market. It runs by itself every Monday morning and looks at three places: providers’ own pricing pages, industry news, and publicly visible user reviews.',
  },
  howToReadSignal: {
    tr: 'Etiketler şöyle okunur: KRİTİK = gerçek bir pazar hareketi, İZLE = sürerse önemli olacak, STABİL = arka plan gürültüsü. Yanında (⚠) olan veriyi henüz teyit edemedik; ona dayanarak karar vermeyin.',
    en: 'How to read the labels: CRITICAL = a real market move, WATCH = will matter if it continues, STABLE = background noise. Anything marked (⚠) is not yet confirmed — don’t base a decision on it.',
  },
  howToReadCadence: {
    tr: 'Her hafta 28 sağlayıcı tek tek taranır, sonra hepsi bir haftalık özete dönüştürülür. Her hafta kaydedilir ve silinmez; sağ üstteki hafta seçiciden geçmiş haftalara dönebilirsiniz.',
    en: 'Each week all 28 providers are checked one by one, then rolled up into a single weekly summary. Every week is saved and kept; use the week selector at the top right to go back through past weeks.',
  },
  howToReadHistory: {
    tr: 'Geçmiş haftaları incelerken: yaklaşık 6 haftalık bir dönemde kullanıcı yorumu verisi eksik ya da güvenilmez kaldı. O boşluğu sonradan doldurmuyoruz — eksik olan yeri eksik gösteriyoruz, tahminle tamamlamıyoruz.',
    en: 'When looking back at past weeks: for a stretch of about 6 weeks the user-review data stayed incomplete or unreliable. We are not backfilling that gap — we show it as missing rather than completing it with guesses.',
  },

  // 'Next week' / project status note
  nextWeekNote: { tr: 'SONRAKİ HAFTA NE AÇILACAK', en: 'WHAT UNLOCKS NEXT WEEK' },
  firstCycleNote: {
    tr: 'Bu, Hafta 21’in ilk çalışmasıdır. Karşılaştıracak önceki hafta henüz olmadığı için haftalık değişim ok ve etiketleri gizlendi.',
    en: 'This is the first run for week 21. Because there is no prior week to compare to yet, week-over-week arrows and labels are hidden.',
  },
  nextWeekUnlocks: {
    tr: 'Hafta 22’den itibaren şunlar açılacak:',
    en: 'Starting next week the following will become available:',
  },
  nextWeekItem1: {
    tr: 'Tema bazında haftalık değişim okları (artıyor / azalıyor / sabit)',
    en: 'Per-theme week-over-week change indicators (rising / falling / steady)',
  },
  nextWeekItem2: {
    tr: '“En büyük hareket” kartı (fiyat veya plan için en büyük deltayı gösterir)',
    en: 'Biggest-mover card (largest week-over-week price or plan delta)',
  },
  nextWeekItem3: {
    tr: 'Sağlayıcı bazında fiyat ve duygu zaman serileri',
    en: 'Per-provider price and sentiment time series',
  },
  nextWeekItem4: {
    tr: 'Hafta-içi mukayese (gelişme / kötüleşme / yeniden açılan tema)',
    en: 'Cross-week comparisons (improving / worsening / re-emerging themes)',
  },
  noPriorWeekShort: { tr: 'Önceki hafta verisi yok', en: 'No prior week data' },
};

/**
 * Returns the translation for a key in the given language.
 * Falls back to English if the key is not found in the target language.
 */
export function t(key: string, lang: Lang): string {
  const entry = dict[key];
  if (!entry) return key;
  return entry[lang] ?? entry['en'] ?? key;
}

/**
 * Returns the display label for a status value.
 */
export function statusLabel(status: 'CRITICAL' | 'WATCH' | 'STABLE', lang: Lang): string {
  return t(status.toLowerCase(), lang);
}

/**
 * Returns the display label for a focus area.
 */
export function focusLabel(focus: string, lang: Lang): string {
  return t(focus.toLowerCase(), lang);
}

/**
 * Returns the display label for a provider category.
 */
export function categoryLabel(category: string, lang: Lang): string {
  return t(category, lang);
}
